import React from 'react';

export const TextStrip = ({ items, speed = 28, reverse = false, className = '' }) => {
  // Triple the list so the marquee can loop seamlessly
  const loop = [...items, ...items, ...items];

  return (
    <div className={`text-strip-band ${className}`} data-testid="text-strip-band">
      <div className="brands-marquee">
        <div
          className={`brands-marquee-track text-strip-track ${reverse ? 'reverse' : ''}`}
          style={{ animationDuration: `${speed}s` }}
        >
          {loop.map((label, index) => (
            <div key={`${label}-${index}`} className="text-strip-item">
              <span className="text-strip-dot" aria-hidden="true">◆</span>
              <span className="text-strip-label">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
